import React from 'react';

const ImageBanner = ({ imageUrl, height = "200px", overlay = true, children }) => {
  return (
    <section 
      style={{
        backgroundImage: `url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        height: height,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {overlay && (
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(58, 46, 15, 0.8) 0%, rgba(172, 153, 105, 0.6) 50%, rgba(58, 46, 15, 0.8) 100%)',
            backdropFilter: 'blur(1px)'
          }}
        />
      )}
      {children && (
        <div 
          style={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
            color: 'white'
          }}
        >
          {children}
        </div>
      )}
    </section>
  );
};

export default ImageBanner;